/**
 * C-22 «Предупреждение перед открытием внешней ссылки».
 *
 * ПС §11, CC §12.5 п. 2: показывается РЕАЛЬНЫЙ домен — тот, куда ссылка ведёт,
 * а не тот, который виден в тексте. Для подозрительных и маскированных ссылок
 * предупреждение обязательно; здесь оно показывается для всех внешних, потому
 * что «выглядит безобидно» — это и есть основной приём маскировки.
 */
import type { ParsedLink } from '@shared/lib/links'
import { Banner, Button, Dialog } from '@shared/ui'

import styles from './message.module.css'

export function ExternalLinkDialog({
  link,
  onClose,
}: {
  link: ParsedLink | null
  onClose: () => void
}): React.ReactElement {
  const suspicious = link?.risk === 'suspicious'

  return (
    <Dialog
      open={link !== null}
      onClose={onClose}
      title="Перейти по ссылке?"
      description="Ссылка ведёт за пределы «Движа»."
      footer={
        <>
          <Button variant="secondary" onClick={onClose}>
            Отмена
          </Button>
          <Button
            variant={suspicious ? 'danger' : 'primary'}
            onClick={() => {
              if (link) {
                // CC §12.5 п. 3: новая вкладка и rel, разрывающий связь с opener.
                globalThis.open(link.href, '_blank', 'noopener,noreferrer')
              }
              onClose()
            }}
          >
            Открыть
          </Button>
        </>
      }
    >
      <p className={styles['linkHostLabel']}>Настоящий адрес</p>
      <p className={styles['linkHost']}>{link?.host}</p>

      {/* Полная ссылка — чтобы было видно и путь, и параметры */}
      <p className={styles['linkFull']}>{link?.href}</p>

      {suspicious ? (
        <Banner tone="danger" icon="alert" title="Адрес выглядит подделанным">
          В домене смешаны алфавиты или спрятан другой адрес — так маскируют ссылки на поддельные сайты.
          Открывайте, только если точно знаете отправителя.
        </Banner>
      ) : null}
    </Dialog>
  )
}
